import React from "react";
import styles from "./BetTableTeenPatti20c.module.css";

// Import card suit icons
import spadeIcon from '../../../../assets/img/cardsIcons/spade.png';
import clubIcon from '../../../../assets/img/cardsIcons/club.png';
import heartIcon from '../../../../assets/img/cardsIcons/heart.png';
import diamondIcon from '../../../../assets/img/cardsIcons/diamond.png';

const BetTableTeenPatti20c = ({ data, onBetClick, playerName, exposures = {} }) => {
  const getScore = (label) => {
    return data?.find((item) => item?.nat === label) || { b: 0 };
  };

  const score = {
    player: getScore(`Player ${playerName}`),
    baccarat: getScore(`3 Baccarat ${playerName}`),
    total: getScore(`Total ${playerName}`),
    pairPlus: getScore(`Pair Plus ${playerName}`),
    black: getScore(`Black ${playerName}`),
    red: getScore(`Red ${playerName}`),
  };

  const renderBetCell = (item, label, displayLabel) => {
    const value = item?.b ?? 0;
    const isLocked = value === 0 || item?.gstatus?.toUpperCase() === "SUSPENDED";
    const exposure = exposures[label] || 0;
    const displayValue = isLocked ? 0 : value;
    const displayText = displayLabel || label;

    return (
      <div className="col-3">
        <div>
          <p className="d-block mb-0 text-center" style={{ color: "white" }}>
            <b>{displayText}</b>
          </p>
          <button
            className={`btn-theme mt-1 ${isLocked ? styles.teenpattiSuspended : ""}`}
            onClick={() => !isLocked && onBetClick(value, label, item)}
            disabled={isLocked}
          >
            {!isLocked && <span>{displayValue}</span>}
          </button>
          <p className="mt-1 mb-0 text-danger text-center" style={{ color: "white" }}>
            {exposure !== 0 ? (exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`) : "0"}
          </p>
        </div>
      </div>
    );
  };

  const renderCardCell = (item, label, cardIcons) => {
    const value = item?.b ?? 0;
    const isLocked = value === 0 || item?.gstatus?.toUpperCase() === "SUSPENDED";
    const exposure = exposures[label] || 0;
    const displayValue = isLocked ? 0 : value;

    return (
      <div className="col-6">
        <div>
          <p className="d-block mb-0 text-center">
            {cardIcons.map((icon, index) => (
              <span key={index} className={styles.cardIcon}>
                <img src={icon.src} alt={icon.alt} className={styles.cardIconImg} />
              </span>
            ))}
          </p>
          <button
            className={`btn-theme mt-1 ${isLocked ? styles.teenpattiSuspended : ""}`}
            onClick={() => !isLocked && onBetClick(value, label, item)}
            disabled={isLocked}
          >
            {!isLocked && <span>{displayValue}</span>}
          </button>
          <p className="mt-1 mb-0 text-danger text-center" style={{ color: "black" }}>
            {exposure !== 0 ? (exposure < 0 ? exposure.toFixed(2) : `+${exposure.toFixed(2)}`) : "0"}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="container-fluid container-fluid-5">
      <div className="row row5 m-t-10">
        <h4 style={{ color: "white" }} className="col-12 teenpatti-20c">Player {playerName}</h4>
        {renderBetCell(score.player, `Player ${playerName}`, `Player ${playerName}`)}
        {renderBetCell(score.baccarat, `3 Baccarat ${playerName}`, `3 Baccarat ${playerName}`)}
        {renderBetCell(score.total, `Total ${playerName}`, `Total ${playerName}`)}
        {renderBetCell(score.pairPlus, `Pair Plus ${playerName}`, `Pair Plus ${playerName}`)}
        {renderCardCell(score.black, `Black ${playerName}`, [
          { src: spadeIcon, alt: "Spade" },
          { src: clubIcon, alt: "Club" }
        ])}
        {renderCardCell(score.red, `Red ${playerName}`, [
          { src: heartIcon, alt: "Heart" },
          { src: diamondIcon, alt: "Diamond" }
        ])}
      </div>
    </div>
  );
};

export default BetTableTeenPatti20c;
